import { useCallback, useState } from "react";
import { RepairItem } from "types/restarter";

type FormSubmissionStatus = "" | "SUCCESS" | "ERROR";

type ReturnType = {
  loading: boolean;
  formSubmitted: FormSubmissionStatus;
  submitRestarterItem: (item: RepairItem) => Promise<boolean>;
};

export const useRestarterItemEdit = (): ReturnType => {
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState<FormSubmissionStatus>("");

  const submitRestarterItem = useCallback(async (item: RepairItem) => {
    setLoading(true);
    setFormSubmitted("");
    const url = `${import.meta.env.REACT_APP_REST_URL}/v1/restarter/repairItemEdit/`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      setFormSubmitted("SUCCESS");
      return true;
    } catch (error) {
      console.error("Failed to submit the repair item:", error);
      setFormSubmitted("ERROR");
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return { submitRestarterItem, loading, formSubmitted };
};
